import type { FunctionComponent } from "react";
import { Company } from "@kanda-libs/ks-frontend-services";
import { Icon, Text } from "@kanda-libs/ks-design-library";

export interface CompanyRowProps {
  company: Company;
  selected?: boolean;
  onSelect?: () => void;
}

const CompanyRow: FunctionComponent<CompanyRowProps> = function ({
  company,
  selected = false,
  onSelect,
}) {
  return (
    <div
      className="flex flex-col p-2 mb-2 border border-solid cursor-pointer gap-y-2 border-neutral-200 rounded-xl"
      onClick={() => {
        onSelect?.();
      }}
    >
      <div className="flex flex-row items-center gap-x-2">
        {selected && <Icon icon="check" size={30} className="text-green-400" />}
        <div className="flex flex-col">
          <Text
            text={[
              company.contact_info?.trading_name,
              company.contact_info?.contact_email,
            ].join(" - ")}
            className="text-16-20-em"
          />
          <Text text={company.id} className="text-14-22" />
        </div>
      </div>
    </div>
  );
};

export default CompanyRow;
